// partners images
import partner1 from "../../assets/images/partners/partner1.png";
import partner2 from "../../assets/images/partners/partner2.png";
import partner3 from "../../assets/images/partners/partner3.png";
import partner4 from "../../assets/images/partners/partner4.png";
import partner5 from "../../assets/images/partners/partner5.png";
import partner6 from "../../assets/images/partners/partner6.png";
import partner7 from "../../assets/images/partners/partner7.png";
import partner8 from "../../assets/images/partners/partner8.png";
import partner9 from "../../assets/images/partners/partner9.png";
import partner10 from "../../assets/images/partners/partner10.png";
import partner11 from "../../assets/images/partners/partner11.png";
import partner12 from "../../assets/images/partners/partner12.png";
import partner13 from "../../assets/images/partners/partner13.png";
import partner14 from "../../assets/images/partners/partner14.png";

const Slider = () => {

    return (
        <div class="partners">
            <h5 class="fade-in">OUR PARTNERS</h5>
        <div class="slider">
	<div class="slide-track">
		<div class="slide">
			<img src={partner1} height="100" width="250" alt="" />
			<img src={partner2} height="100" width="250" alt="" />
			<img src={partner3} height="100" width="250" alt="" />
			<img src={partner4} height="100" width="250" alt="" />
			<img src={partner5} height="100" width="250" alt="" />
			<img src={partner6} height="100" width="250" alt="" />
			<img src={partner7} height="100" width="250" alt="" />
			<img src={partner8} height="100" width="250" alt="" />
			<img src={partner9} height="100" width="250" alt="" />
			<img src={partner10} height="100" width="250" alt="" />
			<img src={partner11} height="100" width="250" alt="" />
			<img src={partner12} height="100" width="250" alt="" />
			<img src={partner13} height="100" width="250" alt="" />
			<img src={partner14} height="100" width="250" alt="" />
		</div>
	</div>
</div>
</div>
    )
}

export default Slider;